import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGlobalConfig } from "../../services/globalConfig/interfaces/IGlobalConfig.interface";
import
{
  getApplicationConfigs,
  getCommonSystem,
  getConfigByKey,
  // getConfigsDetailPage,
  getGlobalConfigs,
  getGroup,
  getInfor,
  getMetakey
} from "../../services/metaKeys/metaKeyService";
import { loadThemeCss } from "../../utils/ultis";

interface IAppCommonState
{
  currentURLPath?: string;

  loadingGlobal?: boolean;
  showOrderTasking?: boolean;

  showPaging?: boolean;
  showFilter?: boolean;
  showSort?: boolean;
  globalConfig?: IGlobalConfig;
  whoami?: any;
  groups?: string[];
  publicConfig?: any;
  roleUsing?: string[];
  showListImagesSearch?: boolean;
  metaKey?: any;
  totalPage?: any;
  pageNumber?: any;
  pageSize?: any;
  dataStatusOrder: any;
  visibleListApp?: boolean;
  isGroupsLoaded?: boolean;
  colorConfig?: any;
  theme?: any;
  allProviders?: any[];
  commonSystem?: any;
  notiAgentTopic?: string;
}

const initialState: IAppCommonState = {
  currentURLPath: undefined,
  loadingGlobal: false,
  showOrderTasking: false,
  showPaging: false,
  showFilter: false,
  showSort: false,
  globalConfig: undefined,
  whoami: {

  },
  groups: [],
  publicConfig: {},
  roleUsing: ['user'],
  showListImagesSearch: false,
  metaKey: [],
  totalPage: 0,
  pageNumber: 0,
  pageSize: 8,
  dataStatusOrder: [],
  visibleListApp: false,
  colorConfig: {},
  isGroupsLoaded: false,
  theme: localStorage.getItem("user-theme-vmrs"),
  allProviders: [],
  commonSystem: {},
  notiAgentTopic: undefined
};

export const getInforAsync = createAsyncThunk(
  "app-common-state/getInfor",
  async () =>
  {
    try
    {
      const response = await getInfor();
      return response;
    } catch (e)
    {
      return {};
    }
  }
);


export const appCommonSlice = createSlice({
  name: "app-common-state",
  initialState,
  reducers: {
    setMetaKey: (state, action: PayloadAction<any>) =>
    {
      state.metaKey = action.payload;
    },
    setCommonSystem: (state, action: PayloadAction<any>) =>
    {
      state.commonSystem = action.payload;
    },
    setDataStatusOrder: (state, action: PayloadAction<any>) =>
    {
      state.dataStatusOrder = action.payload;
    },
    setCurrentURLPath: (state, action: PayloadAction<string | undefined>) =>
    {
      state.currentURLPath = action.payload;
    },



    setLoadingGlobal: (state, action: PayloadAction<boolean>) =>
    {
      state.loadingGlobal = action.payload;
    },

    setShowOrderTasking: (state, action: PayloadAction<boolean>) =>
    {
      state.showOrderTasking = action.payload;
    },

    setShowPaging: (state, action) =>
    {
      state.showPaging = action.payload;
    },

    setShowFilter: (state, action) =>
    {
      state.showFilter = action.payload;
    },

    setTheme: (state, action) =>
    {
      state.theme = action.payload;
      localStorage.setItem("user-theme-vmrs", action.payload); // Lưu vào local khi user đổi
      loadThemeCss(action.payload); // Gọi hàm load CSS ngay lập tức
    },

    setShowSort: (state, action) =>
    {
      state.showSort = action.payload;
    },
    setGlobalConfig: (state, action) =>
    {
      state.globalConfig = action.payload;
    },


    setGroups: (state, action) =>
    {
      state.roleUsing = ['user'];
    },


    setRoleUsing: (state, action: PayloadAction<string[]>) =>
    {
      state.roleUsing = action.payload;
    },
    setPublicConfig: (state, action) =>
    {
      state.publicConfig = action.payload;
    },

    setColorConfig: (state, action) =>
    {
      state.colorConfig = action.payload;
    },

    changeShowListImagesSearch: (state, action) =>
    {
      state.showListImagesSearch = action.payload;
    },

    setTotalPage: (state, action) =>
    {
      state.totalPage = action.payload;
    },

    setPageNumber: (state, action) =>
    {
      state.pageNumber = action.payload;
    },

    changeVisibleListApp: (state, action) =>
    {
      state.visibleListApp = action.payload;
    },

    resetStateFooter: (state) =>
    {
      state.showFilter = false;
      state.showPaging = false;
      state.showSort = false;

      state.totalPage = 0;
      state.pageNumber = 0;
      state.pageSize = 8;
    },

    setAllProviders: (state, action) =>
    {
      state.allProviders = action.payload;
    },

    setWhoami: (state, action: PayloadAction<any>) =>
    {
      state.whoami = action.payload;
    },

    setNotiAgentTopic: (state, action: PayloadAction<string | undefined>) =>
    {
      state.notiAgentTopic = action.payload;
    },
  },
  extraReducers: (builder) =>
  {
    builder.addCase(getInforAsync.fulfilled, (state, action: any) =>
    {
      const data = action.payload?.data;
      if (data) state.whoami = data;
    });
  },
});

export const getMetakeyAsync = createAsyncThunk(
  "app-common-state/getMetakey",
  async (payload) =>
  {
    try
    {
      const response = await getMetakey(payload);
      return response;
    } catch (e)
    {
      return {};
    }
  }
);

export const getGlobalConfigsAsync = createAsyncThunk(
  "app-common-state/getGlobalConfigs",
  async (payload: any) =>
  {
    try
    {
      const response = await getGlobalConfigs(payload);
      return response;
    } catch (e)
    {
      return {};
    }
  }
);

export const getGroupAsync = createAsyncThunk(
  "app-common-state/getGroup",
  async () =>
  {
    try
    {
      const response = await getGroup();
      return response;
    } catch (e)
    {
      return {};
    }
  }
);

export const getApplicationConfigsAsync = createAsyncThunk(
  "app-common-state/getApplicationConfigs",
  async (payload: any) =>
  {
    try
    {
      const response = await getApplicationConfigs();
      return response;
    } catch (e)
    {
      return {};
    }
  }
);


// export const getConfigsDetailPageAsync = createAsyncThunk(
//   "app-common-state/getConfigsDetailPage",
//   async (key: string) =>
//   {
//     try
//     {
//       const response = await getConfigsDetailPage(key);
//       return response;
//     } catch (e)
//     {
//       return {};
//     }
//   }
// );

export const getCommonSystemAsync = createAsyncThunk(
  "app-common-state/getCommonSystem",
  async () =>
  {
    try
    {
      const response = await getCommonSystem();
      return response;
    } catch (e)
    {
      return {};
    }
  }
);

// The websocket notification channel (topic) is stored server-side as a
// config key. Fetched once after login and cached in the store; the
// notification websocket uses it instead of config.json's static value.
export const getNotiAgentTopicAsync = createAsyncThunk(
  "app-common-state/getNotiAgentTopic",
  async () =>
  {
    try
    {
      const response = await getConfigByKey("vmrs_core_agent_topic");
      return response;
    } catch (e)
    {
      return {};
    }
  }
);

export const {
  setCurrentURLPath,

  setLoadingGlobal,
  setShowOrderTasking,
  setShowPaging,
  setShowSort,
  setShowFilter,
  setGlobalConfig,

  setGroups,
  setPublicConfig,
  changeShowListImagesSearch,
  setRoleUsing,
  setMetaKey,
  resetStateFooter,
  setTotalPage,
  setPageNumber,
  setDataStatusOrder,
  changeVisibleListApp,
  setColorConfig,
  setTheme,
  setAllProviders,
  setCommonSystem,
  setNotiAgentTopic
} = appCommonSlice.actions;

export default appCommonSlice.reducer;
